import React, { FC, ReactNode } from 'react';
import { InView } from 'react-intersection-observer';

import useAnalytics from '~/client/lib/segment/useAnalytics';
import usePageViewId from '~/client/lib/segment/usePageViewId';

interface SegmentImpressionProps {
  children: ReactNode;
  className?: string;
  eventName: string;
  eventProps?: Record<string, any>;
}

const SegmentImpression: FC<SegmentImpressionProps> = ({
  children,
  className,
  eventName,
  eventProps = {},
}) => {
  const { trackSegmentTrackEvent } = useAnalytics();
  const pageViewId = usePageViewId();
  const handleViewChange = (inView: boolean) => {
    if (inView) {
      trackSegmentTrackEvent(eventName, pageViewId, eventProps);
    }
  };

  return (
    <InView className={className} onChange={handleViewChange} triggerOnce>
      {children}
    </InView>
  );
};

export default SegmentImpression;
